<template lang="html">
  <section class="wcc section summary">
    <div class="wcc summary-contents">
      <template  v-if="listingGrossCommissions">
        <h3>Listing Gross Commissions</h3>
        <article class="wcc field">
          {{listingGrossCommissions}}
        </article>
      </template>
      <template v-if="buyingAgentCommission">
        <h3>Buying Agent Commission</h3>
        <article class="wcc field">
          {{buyingAgentCommission}}
        </article>
      </template>
      <template v-if="buyingAgentBonus > 0">
        <h3>Buying Agent Bonus</h3>
        <article class="wcc field">
          $ {{numberWithCommas(buyingAgentBonus)}}
        </article>
      </template>    
    </div>
  </section>
</template>
<script>
  export default {
    props: ['calculatorData'],
    methods: {
      commissionStr(commissionData) {
        if (commissionData.type == 'flat') {
          return `${commissionData.rate.value}%`
        } else if (commissionData.type == 'split') {
          return `${commissionData.rate1.value}% to $${this.numberWithCommas(commissionData.threshold.value)} then ${commissionData.rate2.value}%`
        }
        return commissionData
      }
    },
    computed: {
      listingGrossCommissions() {
        let commissionData = this.calculatorData.listingGrossCommissions.value
        if (commissionData) {
          return this.commissionStr(commissionData)
        } else {
          return ''
        }
      },
      buyingAgentCommission() {
        let commissionData = this.calculatorData.buyingAgentCommission.value
        if (commissionData) {
          return this.commissionStr(commissionData)
        } else {
          return ''
        }
      },
      buyingAgentBonus() {
        let commissionData = this.calculatorData.buyingAgentCommission.value
        if (commissionData) {
          return commissionData.bonus.value
        } else {
          return 0
        }
      }
    }
  }
</script>
<style lang="scss">
.wcc.summary {
    background-color: white;
  .wcc.summary-contents {
    margin: $spacing;
    h3:first-of-type {
      margin-top: 0;
    }
  }
}
</style>